import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=dfce4622&scoped=true&"
import script from "./DropdownButton.vue?vue&type=script&lang=js&"
export * from "./DropdownButton.vue?vue&type=script&lang=js&"
import style0 from "./DropdownButton.vue?vue&type=style&index=0&id=dfce4622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfce4622",
  null
  
)

export default component.exports